export default {
  brandGroups: [],
  calculations: [],
  chargeProfiles: [],
  countries: [],
  currencies: [],
  dataOptions: [],
  dataOptionTypes: [],
  exchangeRates: [],
  financialCodes: [],
  jobTypes: [],
  lineDescriptorProperty: [],
  noteDescriptorProperty: [],
  roles: [],
  partyGroups: [],
  portAreas: [],
  serviceTypes: [],
  staticDescriptorProperty: [],
  tariffDescriptorProperty: [],
  userGroups: []
}



// WEBPACK FOOTER //
// ./src/modules/systemoptions/store/state.js